module.exports = __webpack_public_path__ + "static/media/brewmaster.c5e8833f.png";